import { Cohort } from "../constants/rootConstants";

const getPathFromPageId = ({ cohort, pageId }: { cohort: Cohort; pageId: string }): string => {
  return `${cohort}/${pageId}`;
};

export default getPathFromPageId;
